/**
 * @generated SignedSource<<56812393acaff750bac4483b1202d449>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveBoleto_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ChargePrintPDF_charge" | "PaymentActiveBarcode_charge" | "PaymentActiveBoletoDelinquencyWarning_charge" | "PaymentLinkActiveEarnDiscount_charge" | "PaymentLinkActiveQrCode_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentLinkShareButton_charge" | "PaymentMethodBoletoValue_charge" | "PaymentMethodPaymentDeadline_charge" | "PaymentMethodTransactionDetails_charge" | "useChargePaymentMethod_charge">;
  readonly " $fragmentType": "PaymentActiveBoleto_charge";
};
export type PaymentActiveBoleto_charge$key = {
  readonly " $data"?: PaymentActiveBoleto_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveBoleto_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveBoleto_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnDiscount_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkShareButton_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveBarcode_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useChargePaymentMethod_charge",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availablePaymentMethods",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "brCode",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "valueWithDiscount",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodPix",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "PaymentMethodInstallments",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "installmentNumber",
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "type": "PaymentMethodCreditCard",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "consentId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authorizationUrl",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodITP",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoBarcode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoDigitable",
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "type": "PaymentMethodBoleto",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPaymentDeadline_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodBoletoValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveBoletoDelinquencyWarning_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveQrCode_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChargePrintPDF_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "d77284f73f7a81504daf9fd8fe9e8c30";

export default node;
